<template>
  <div class="render-canvas" id="babylon">
    <div ref="loadingScreen" class="loadingScreen"></div>
    <canvas ref="renderCanvas" id="renderCanvas" @click="canvasclick"></canvas>
  </div>
</template>

<style lang="scss" scoped>
.render-canvas {
  width: 100%;
  height: 100%;
  overflow: hidden;

  #renderCanvas {
    touch-action: none;
    outline: none;
    width: 100%;
    height: 100%;
  }

  .loadingScreen {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: $main_header;
    transition: opacity 2s ease-in;
    z-index: 1;
    pointer-events: none;
  }
}
</style>

<script>
import * as BABYLON from "babylonjs";
import * as GUI from "babylonjs-gui";
import mixin from "../../lib/mixins.js";
import { transformCoordinates } from "../../lib/math";

export default {
  props: [
    "typ_house_value",
    "pos_status_value",
    "show_status",
    "current_position",
    "pos_position_select",
    "app_language",
  ],
  mixins: [mixin],
  data: function () {
    return {
      engine: null,
      cameraAnimation: null,
      camera: null,
      scene: null,
      canvas: null,
      containers: {
        1: [],
        2: [],
      },
      status: false,
      rectangles: {},
      texts: {},
      sprite_manager: null,
      sprites: {
        normal: {},
        selected: {},
        potvrda: {},
        intervencija: {},
      },
      advancedTexture: null,
    };
  },
  watch: {
    typ_house_value: function () {
      this.loadHouse();
    },
    pos_status_value: function () {
      if (this.scene) {
        this.setMeshColor(this.scene);
      }
    },
    show_status: function () {
      this.setMeshColor(this.scene);
    },
    current_position: function () {
      this.setMeshColor(this.scene);
    },
    pos_position_select: function () {
      this.setTexts();
    },
  },
  methods: {
    getScalingAnimations: function (name, from, to) {
      const scaleX = new BABYLON.Animation(
        name,
        "scaling.x",
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      const scaleY = new BABYLON.Animation(
        name,
        "scaling.y",
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      const scaleZ = new BABYLON.Animation(
        name,
        "scaling.z",
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      const keys = [];
      keys.push({
        frame: 0,
        value: from,
      });
      keys.push({
        frame: 1,
        value: to,
      });

      scaleX.setKeys(keys);
      scaleY.setKeys(keys);
      scaleZ.setKeys(keys);
      return { scaleX, scaleY, scaleZ };
    },
    clearAllMeshes: function () {
      if (this.scene) {
        for (const mesh of this.scene.meshes) {
          this.scene.removeMesh(mesh, true);
        }
      }
    },
    tagAllMeshes: function (name) {
      if (this.scene) {
        for (const mesh of this.scene.meshes) {
          this.tagMesh(mesh, name);
        }
      }
    },
    addClickToHouse: function () {
      const _that = this;
      if (this.scene) {
        for (const mesh of this.scene.getMeshesByTags("house")) {
          mesh.actionManager = new BABYLON.ActionManager(this.scene);
          mesh.actionManager.registerAction(
            new BABYLON.ExecuteCodeAction(
              {
                trigger: BABYLON.ActionManager.OnPickTrigger,
              },
              function () {
                if (!_that.status) {
                  _that.animateUp();
                } else {
                  _that.animateDown();
                }
                _that.status = !_that.status;
              }
            )
          );
        }
      }
    },
    tagMesh: function (mesh, name) {
      BABYLON.Tags.EnableFor(mesh);
      mesh.addTags(name);
    },
    animateUp: function () {
      const scale = this.getScalingAnimations("housedown", 1, 0.1);
      for (const mesh of this.scene.getMeshesByTags("house")) {
        mesh.animations = [];
        mesh.animations.push(scale.scaleX);
        mesh.animations.push(scale.scaleY);
        mesh.animations.push(scale.scaleZ);
        this.scene.beginAnimation(mesh, 0, 1, false, 0.1);
      }

      this.containers["1"][0].addAllToScene();
      this.containers["1"][1].addAllToScene();

      const scale1 = this.getScalingAnimations("orbitalup", 0.01, 1);
      for (const mesh of this.scene.getMeshesByTags("orbital")) {
        mesh.animations = [];
        mesh.animations.push(scale1.scaleX);
        mesh.animations.push(scale1.scaleY);
        mesh.animations.push(scale1.scaleZ);
        this.scene.beginAnimation(mesh, 0, 1, false, 0.1);
      }
    },
    animateDown: function () {
      const scale = this.getScalingAnimations("houseup", 0.1, 1);
      for (const mesh of this.scene.getMeshesByTags("house")) {
        mesh.animations = [];
        mesh.animations.push(scale.scaleX);
        mesh.animations.push(scale.scaleY);
        mesh.animations.push(scale.scaleZ);
        this.scene.beginAnimation(mesh, 0, 1, false, 0.1);
      }

      const scale1 = this.getScalingAnimations("orbitaldown", 1, 0.01);
      for (const mesh of this.scene.getMeshesByTags("orbital")) {
        mesh.animations = [];
        mesh.animations.push(scale1.scaleX);
        mesh.animations.push(scale1.scaleY);
        mesh.animations.push(scale1.scaleZ);
        this.scene.beginAnimation(mesh, 0, 1, false, 0.1);
      }
    },
    canvasclick: function () {
      this.stopCameraAnimation();
    },
    stopCameraAnimation: function () {
      if (this.cameraAnimation) {
        this.cameraAnimation.stop();
        // this.camera.attachControl(this.$refs.renderCanvas, true);
        this.cameraAnimation = null;
        //this.animateUp();
      }
    },
    createTextObjects(scene, advancedTexture, animations) {
      for (const mesh of scene.meshes) {
        if (mesh.name.startsWith("POS_")) {
          let rect1 = new GUI.Rectangle();
          advancedTexture.addControl(rect1);
          rect1.width = "200px";
          // rect1.height = "30px";
          rect1.thickness = 1;
          rect1.linkOffsetX = "0px";
          rect1.linkOffsetY = "-50px";
          rect1.transformCenterX = 0.5;
          rect1.transformCenterY = 0.5;
          rect1.background = "#4e8a9b";
          rect1.alpha = 0.8;
          rect1.scaleX = 0;
          rect1.scaleY = 0;
          rect1.cornerRadius = 30;
          rect1.linkWithMesh(mesh);
          // rect1.isVisible = false;
          rect1.adaptWidthToChildren = true;
          rect1.adaptHeightToChildren = true;
          rect1.horizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
          rect1.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
          rect1.paddingTop = "-5px";
          rect1.paddingBottom = "-5px";
          rect1.paddingLeft = "-10px";
          rect1.paddingRight = "-10px";
          rect1.animations = [];
          // rect1.animations.push(scaleXAnimation);
          rect1.animations.push(...animations);

          let text1 = new GUI.TextBlock();
          text1.resizeToFit = true;
          // text1.text = mesh.name;
          text1.color = "White";
          text1.fontSize = 14;
          text1.textWrapping = GUI.TextWrapping.WordWrap;
          text1.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
          rect1.addControl(text1);
          text1.alpha = 3;
          text1.width = "125px";
          text1.height = "25px";
          // text.width = 1.0;
          // text.height = 1.0;
          text1.resizeToFit = true;

          this.rectangles[mesh.name] = rect1;
          this.texts[+mesh.name.substring(4)] = text1;
        }
      }
    },
    setTexts() {
      for (const [pos, text] of Object.entries(this.texts)) {
        text.text = this.pos_position_select[pos];
      }
    },
    addToActionManager(scene, actionManager) {
      for (const mesh of scene.meshes) {
        if (mesh.name.startsWith("POS_")) {
          mesh.actionManager = actionManager;
        }
      }
      // for (const key in this.sprites) {
      //   if (this.sprites.hasOwnProperty(key)) {
      //     const element = this.sprites[key];
      //     for (const innerkey in element) {
      //       if (element.hasOwnProperty(innerkey)) {
      //         const innerelement = element[innerkey];
      //         innerelement.actionManager = actionManager;
      //       }
      //     }
      //   }
      // }
    },
    // redefineMeshColor: function(scene) {
    // for (const mesh of scene.meshes) {
    //   if (mesh.name.startsWith("POS_")) {
    //     const newMaterial = mesh.material.clone("mat_" + mesh.name);
    //     mesh.material = newMaterial;
    //     let oldColor = mesh.material.albedoColor;
    //     mesh.material.albedoColor = new BABYLON.Color3(oldColor.r, oldColor.g, oldColor.b);
    //   }
    // }
    // },
    setMeshColor(scene) {
      for (const mesh of scene.meshes) {
        if (mesh.name.startsWith("POS_")) {
          const pos = +mesh.name.substring(4);
          if (this.pos_status_value[pos] && pos != 10 && pos != 13) {
            if (this.show_status && pos == +this.current_position) {
              this.sprites.normal[mesh.name].isVisible = false;
              this.sprites.selected[mesh.name].isVisible = true;
              this.sprites.potvrda[mesh.name].isVisible = false;
              this.sprites.intervencija[mesh.name].isVisible = false;
            } else if (this.pos_status_value[pos].status == 0 && this.pos_status_value[pos].potvrda == false) {
              this.sprites.normal[mesh.name].isVisible = true;
              this.sprites.selected[mesh.name].isVisible = false;
              this.sprites.potvrda[mesh.name].isVisible = false;
              this.sprites.intervencija[mesh.name].isVisible = false;
            } else if (this.pos_status_value[pos].status == 0 && this.pos_status_value[pos].potvrda == true) {
              this.sprites.normal[mesh.name].isVisible = false;
              this.sprites.selected[mesh.name].isVisible = false;
              this.sprites.potvrda[mesh.name].isVisible = true;
              this.sprites.intervencija[mesh.name].isVisible = false;
            } else if (this.pos_status_value[pos].status == 1) {
              this.sprites.normal[mesh.name].isVisible = false;
              this.sprites.selected[mesh.name].isVisible = false;
              this.sprites.potvrda[mesh.name].isVisible = false;
              this.sprites.intervencija[mesh.name].isVisible = true;
            }
          }
        }
      }
    },
    getCameraAnimations: function (pos) {
      let position = this.sprites.normal["POS_" + ("" + pos).padStart(2, "0")].position;
      let { alpha, beta } = transformCoordinates(position.x, position.y - 1.5, position.z);
      beta = Math.min(1.6, beta);
      beta = Math.max(1.2, beta);

      const lat1 = alpha;
      const lat2 = this.camera.alpha;
      const delta_lat = lat1 - lat2;
      const delta_lng = beta - this.camera.beta;

      const a =
        Math.sin(delta_lat / 2) * Math.sin(delta_lat / 2) +
        Math.cos(lat1) * Math.cos(lat2) * Math.sin(delta_lng / 2) * Math.sin(delta_lng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      let frames = Math.round((c * 60) / Math.PI);
      frames = Math.max(15, frames);
      let cameraAlphaAnimation = new BABYLON.Animation(
        "camera",
        "alpha",
        60,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );
      let cameraBetaAnimation = new BABYLON.Animation(
        "camera",
        "beta",
        60,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      const keysAlpha = [];

      keysAlpha.push({
        frame: 0,
        value: this.camera.alpha,
      });
      keysAlpha.push({
        frame: frames,
        value: alpha,
      });

      cameraAlphaAnimation.setKeys(keysAlpha);

      const keysBeta = [];

      keysBeta.push({
        frame: 0,
        value: this.camera.beta,
      });
      keysBeta.push({
        frame: frames,
        value: beta,
      });

      cameraBetaAnimation.setKeys(keysBeta);
      return { cameraAlphaAnimation, cameraBetaAnimation };
    },
    animateCamera: function (pos) {
      const { cameraAlphaAnimation, cameraBetaAnimation } = this.getCameraAnimations(pos);
      this.camera.animations = [cameraAlphaAnimation, cameraBetaAnimation];
      this.scene.beginAnimation(this.camera, 0, 60, false);
    },
    getAnimations: function () {
      let scaleXAnimation = new BABYLON.Animation(
        "myAnimation",
        "scaleX",
        60,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );
      let scaleYAnimation = new BABYLON.Animation(
        "myAnimation",
        "scaleY",
        60,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT
      );

      var keys = [];

      keys.push({
        frame: 0,
        value: 0,
      });
      keys.push({
        frame: 10,
        value: 1,
      });

      scaleXAnimation.setKeys(keys);
      scaleYAnimation.setKeys(keys);

      return { scaleXAnimation, scaleYAnimation };
    },
    loadStartAnimation: function (alpha) {
      const animationBox = new BABYLON.Animation(
        "cameraAnimation",
        "alpha",
        40,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      );

      const keys = [];
      for (let i = 0; i <= 359; i++) {
        let j = i + alpha + 0.5;
        keys.push({
          frame: i,
          value: (Math.PI / 180) * j,
        });
        j = i + alpha + 1;
        keys.push({
          frame: i,
          value: (Math.PI / 180) * j,
        });
      }

      animationBox.setKeys(keys);
      return animationBox;
    },
    createSprites: function (scene) {
      for (const mesh of scene.meshes) {
        if (mesh.name.startsWith("POS_")) {
          const pos = +mesh.name.substring(4);
          if (pos == 10 || pos == 13) {
            mesh.isPickable = false;
          } else {
            if (this.pos_status_value[pos]) {
              for (const [index, status] of ["normal", "selected", "potvrda", "intervencija"].entries()) {
                this.sprites[status][mesh.name] = new BABYLON.Sprite(status + "_" + mesh.name, this.sprite_manager);
                this.sprites[status][mesh.name].cellIndex = index;
                this.sprites[status][mesh.name].position.x = mesh.position.x;
                this.sprites[status][mesh.name].position.y = mesh.position.y;
                this.sprites[status][mesh.name].position.z = mesh.position.z;
                this.sprites[status][mesh.name].size = 1.6;
                this.sprites[status][mesh.name].isPickable = false;
                this.sprites[status][mesh.name].isVisible = false;
              }
            }
          }

          //mesh.isVisible = false;
        }
      }
    },
    loadHouse: function () {
      this.engine.stopRenderLoop();
      this.engine.displayLoadingUI();
      const _that = this;
      const scene = this.scene;
      if (scene) {
        try {
          const advancedTexture = this.advancedTexture;
          const spriteManager = this.sprite_manager;
          this.scene = null;
          this.cameraAnimation = null;
          this.camera = null;
          this.rectangles = {};
          this.texts = {};
          this.sprite_manager = null;
          this.sprites = {
            normal: {},
            selected: {},
            potvrda: {},
            intervencija: {},
          };
          this.advancedTexture = null;
          if (advancedTexture) {
            advancedTexture.dispose();
          }
          if (spriteManager) {
            spriteManager.dispose();
          }

          scene.cameras.forEach(function (e) {
            e.dispose();
          });
          scene.cameras = [];
          scene.lights.forEach(function (e) {
            e.dispose();
          });
          scene.lights = [];
          scene.meshes.forEach(function (e) {
            e.dispose();
          });
          scene.meshes = [];
          scene.skeletons.forEach(function (e) {
            e.dispose();
          });
          scene.skeletons = [];
          scene.animationGroups.forEach(function (e) {
            e.dispose();
          });
          scene.animationGroups = [];
          scene.multiMaterials.forEach(function (e) {
            e.dispose();
          });
          scene.multiMaterials = [];
          scene.materials.forEach(function (e) {
            e.dispose();
          });
          scene.materials = [];
          scene.geometries.forEach(function (e) {
            e.dispose();
          });
          scene.geometries = [];
          scene.transformNodes.forEach(function (e) {
            e.dispose();
          });
          scene.transformNodes = [];
          scene.actionManagers.forEach(function (e) {
            e.dispose();
          });
          scene.actionManagers = [];
          scene.textures.forEach(function (e) {
            e.dispose();
          });
          scene.textures = [];

          if (scene.reflectionProbes) {
            scene.reflectionProbes.forEach(function (e) {
              e.dispose();
            });
            scene.reflectionProbes = [];
          }

          if (scene.environmentTexture) {
            scene.environmentTexture.dispose();
            scene.environmentTexture = null;
          }
          for (var e = 0, t = scene._serializableComponents; e < t.length; e++) {
            t[e].removeFromContainer(scene, !0);
          }
        } catch (e) {
          console.log(e);
        }
      }

      BABYLON.SceneLoader.Load("", this.typ_house_value + ".babylon", _that.engine, function (scene) {
        //as this .babylon example hasn't camera in it, we have to create one
        _that.sprite_manager = new BABYLON.SpriteManager("pozicija_manager", "sprites.png", 100, 100, scene);
        _that.sprite_manager.isPickable = true;
        _that.scene = scene;
        _that.camera = _that.scene.cameras[0];
        _that.camera.lowerRadiusLimit = 10;
        _that.camera.upperRadiusLimit = 26;
        _that.camera.wheelPrecision = 15;
        if (_that.typ_house_value !== "ao") {
          _that.camera.lockedTarget = null;
          _that.camera.setTarget(new BABYLON.Vector3(0, 1, 0));
        }
        _that.scene.activeCamera = _that.camera;
        // _that.camera.animations.push(_that.loadStartAnimation(_that.camera.alpha));
        // _that.cameraAnimation = _that.scene.beginAnimation(_that.camera, 0, 718, true);
        _that.camera.attachControl(_that.$refs.renderCanvas, true);

        _that.advancedTexture = GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI");
        const { scaleXAnimation, scaleYAnimation } = _that.getAnimations();
        const actionManager = new BABYLON.ActionManager(scene);

        _that.advancedTexture.useInvalidateRectOptimization = false;
        _that.createTextObjects(scene, _that.advancedTexture, [scaleXAnimation, scaleYAnimation]);
        _that.setTexts();
        // _that.redefineMeshColor(scene);
        _that.createSprites(scene, actionManager);
        _that.setMeshColor(scene);

        _that.addToActionManager(scene, actionManager);

        actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function (ev) {
            const pos = +ev.source.name.substring(ev.source.name.indexOf("_") + 1);
            if (pos != 10 && pos != 13) {
              scene.beginAnimation(_that.rectangles[ev.source.name], 0, 10, false);
            }
          })
        );
        // //if hover is over remove highlight of the mesh
        actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function (ev) {
            const pos = +ev.source.name.substring(ev.source.name.indexOf("_") + 1);
            if (pos != 10 && pos != 13) {
              scene.beginAnimation(_that.rectangles[ev.source.name], 10, 0, false);
            }
          })
        );

        actionManager.registerAction(
          new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnLeftPickTrigger, function (ev) {
            const pos = +ev.source.name.substring(ev.source.name.indexOf("_") + 1);
            if (pos != 10 && pos != 13) {
              scene.beginAnimation(_that.rectangles[ev.source.name], 10, 0, false);
              _that.$emit("navigate", [pos, false]);
            }
          })
        );

        _that.engine.hideLoadingUI();
        _that.engine.runRenderLoop(function () {
          scene.render();
        });

        window.addEventListener("resize", function () {
          _that.engine.resize();
        });
      });
    },
  },
  mounted: function () {
    const loadingScreenDiv = this.$refs.loadingScreen;

    function customLoadingScreen() {}

    customLoadingScreen.prototype.displayLoadingUI = function () {
      loadingScreenDiv.style.opacity = 1;
    };
    customLoadingScreen.prototype.hideLoadingUI = function () {
      loadingScreenDiv.style.opacity = 0;
    };

    const loadingScreen = new customLoadingScreen();

    // get the canvas DOM element
    this.canvas = document.getElementById("renderCanvas");

    // load the 3D engine
    this.engine = new BABYLON.Engine(this.canvas, true);
    this.engine.loadingScreen = loadingScreen;
    this.loadHouse();
    // const _that = this;
    // window.addEventListener("resize", function() {
    //   _that.engine.resize();
    // });
    this.$emit("send_methods", { camera_animation: this.animateCamera });
  },
};
</script>
